import Vue from 'vue'
import Router from 'vue-router'
//import Login from '@/components/Login'
// import Home from '@/components/Home'
// import Store from '@/components/Store'
// import Cashier from '@/components/Cashier'
// import Analytics from '@/components/Analytics/Analytics.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      // component: Login
      component: () => import('@/components/Login')
    },
    {
      path: '/TestFunction',
      name: 'TestFunction',
      // component: Login
      component: () => import('@/components/Test/TestFunction')
    },
    {
      path: '/Authorization',
      name: 'Authorization',
      // component: Login
      component: () => import('@/components/Authorization/Authorization')
    },
    {
      path: '/AuthorizationV2',
      name: 'AuthorizationV2',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationV2')
    },

    {
      path: '/AuthorizationMiniCarItemRanking',
      name: 'AuthorizationMiniCarItemRanking',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationMiniCarItemRanking')
    },
    {
      path: '/AuthorizationMiniCardRealTime',
      name: 'AuthorizationMiniCardRealTime',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationMiniCardRealTime')
    },
    {
      path: '/AuthorizationMiniRanKingScreen',
      name: 'AuthorizationMiniRanKingScreen',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationMiniRanKingScreen')
    },
    {
      path: '/AuthorizationMiniCarOneCircleRanking',
      name: 'AuthorizationMiniCarOneCircleRanking',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationMiniCarOneCircleRanking')
    },
    {
      path: '/AuthorizationMiniCarOneCircleRanking2',
      name: 'AuthorizationMiniCarOneCircleRanking2',
      // component: Login
      component: () => import('@/components/Authorization/AuthorizationMiniCarOneCircleRanking2')
    },


    {
      path: '/MiniRanKingScreen',
      name: 'MiniRanKingScreen',
      component: () => import('@/components/Analytics/Ranking/MiniRanKingScreen.vue')
    },
    {
      path: '/MiniCarItemRanking',
      name: 'MiniCarItemRanking',
      component: () => import('@/components/Analytics/Ranking/MiniCarItemRanking.vue')
    },
    {
      path: '/MiniCardRealTime',
      name: 'MiniCardRealTime',
      component: () => import('@/components/Analytics/Ranking/MiniCardRealTime.vue')
    },
    {
      path: '/MiniCarOneCircleRanking',
      name: 'MiniCarOneCircleRanking',
      component: () => import('@/components/Analytics/Ranking/MiniCarOneCircleRanking.vue')
    },
    {
      path: '/MiniCarOneCircleRanking2',
      name: 'MiniCarOneCircleRanking2',
      component: () => import('@/components/Analytics/Ranking/MiniCarOneCircleRanking2.vue')
    },
    {
      path: '/ChainStoreUI',
      name: 'ChainStoreUI',
      component: () => import('@/components/ChainStoreUI/ChainStoreUI.vue'),
      children: [ //二级路由
        {
          path: 'ChainStoreSurveyFunction',
          name: 'ChainStoreSurveyFunction',
          component: () => import('@/components/ChainStoreUI/ChainStoreSurveyFunction.vue'),

        },
        {
          path: 'ChainStoreReportFormFunction',
          name: 'ChainStoreReportFormFunction',
          component: () => import('@/components/ChainStoreUI/ChainStoreReportFormFunction.vue'),

        },
        // {
        //     path: "ChainStoreAccountLevelFunction",
        //     name: "ChainStoreAccountLevelFunction",
        //     component: () => import('@/components/ChainStoreUI/ChainStoreAccountLevelFunction.vue')
        //   },
        {
          path: "AccountLevelSet",
          name: "AccountLevelSet",
          component: () => import('@/components/SystemSetting/Accounts/AccountLevelSet.vue')
        },

        {
          path: "PermissionSet",
          name: "PermissionSet",
          component: () => import('@/components/SystemSetting/Permission/PermissionSet.vue')
        },
        {
          path: "AccountSet",
          name: "AccountSet",
          component: () => import('@/components/SystemSetting/Accounts/AccountSet.vue')
        },
      ]

    },

    {
      path: '/CloudLink',
      name: 'CloudLink',
      component: () => import('@/components/CloudLink/CloudLink.vue'),
    },
    {
      path: '/Home',
      name: 'Home',
      component: () => import('@/components/Home'),
    },
    {
      path: '/ModuleGroup',
      name: 'ModuleGroup',
      component: () => import('@/components/ModuleGroup.vue'),
      children: [ //二级路由
        {
          path: 'Analytics',
          name: 'Analytics',
          component: () => import('@/components/Analytics/Analytics.vue'),
          children: [{
              path: "AccountStatisticsSet",
              name: "AccountStatisticsSet",
              component: () => import('@/components/Analytics/AccountStatistics/AccountStatisticsSet.vue'),
            },
            {
              path: "AnalyticsSet",
              name: "AnalyticsSet",
              component: () => import('@/components/Analytics/AccountStatistics/AccountStatisticsSet.vue'),
            },
            {
              path: "HistoryAnalyticsFunction",
              name: "HistoryAnalyticsFunction",
              component: () => import(
                '@/components/Analytics/AccountStatistics/HistoryAnalyticsFunction.vue'),
            },
            {
              path: "CommodityDataQuerySet",
              name: "CommodityDataQuerySet",
              component: () => import('@/components/Analytics/DataQuery/CommodityDataQuerySet.vue'),
            },
            {
              path: "ItemDataQuerySet",
              name: "ItemDataQuerySet",
              component: () => import('@/components/Analytics/DataQuery/ItemDataQuerySet.vue'),
            },
            {
              path: "MealDataQuerySet",
              name: "MealDataQuerySet",
              component: () => import('@/components/Analytics/DataQuery/MealDataQuerySet.vue'),
            },
            {
              path: "MemberDataQuerySet",
              name: "MemberDataQuerySet",
              component: () => import('@/components/Analytics/DataQuery/MemberDataQuerySet.vue'),
            },
            {
              path: "StorageDataQuerySet",
              name: "StorageDataQuerySet",
              component: () => import('@/components/Analytics/DataQuery/StorageDataQuerySet.vue'),
            },
            {
              path: "HistoryDataQueryFunction",
              name: "HistoryDataQueryFunction",
              component: () => import('@/components/Analytics/DataQuery/HistoryDataQueryFunction.vue'),
            },
            {
              path: "StaffDataQueryFunction",
              name: "StaffDataQueryFunction",
              component: () => import('@/components/Analytics/DataQuery/StaffDataQueryFunction.vue'),
            },
            {
              path: "MembersMoneyPayItemRecordFunction",
              name: "MembersMoneyPayItemRecordFunction",
              component: () => import('@/components/Record/MembersMoneyPayItemRecordFunction.vue')
            },
            {
              path: "MembersMoneyPayItemRecord_History1Function",
              name: "MembersMoneyPayItemRecordFunction",
              component: () => import('@/components/Record/MembersMoneyPayItemRecord_History1Function.vue')
            },

            {
              path: "AmountRecordedFunction",
              name: "AmountRecordedFunction",
              component: () => import('@/components/Record/AmountRecordedFunction.vue')
            },
            {
              path: 'LoginRecord',
              name: 'LoginRecord',
              component: () => import('@/components/Query/LoginRecord.vue')
            },
            {
              path: "MiniCarRankingFunction",
              name: "MiniCarRankingFunction",
              component: () => import('@/components/Analytics/Ranking/MiniCarRankingFunction.vue')
            },

          ]
          //component: () => import('@/components/ModuleGroup.vue'),
          //component: () => import('@/components/Analytics/Analytics.vue'),
        },
        {
          path: 'BaseSetting',
          name: 'BaseSetting',
          component: () => import('@/components/BaseSetting/BaseSetting.vue'),
          children: [{
              path: "DeductionSortSetFunction",
              name: "DeductionSortSetFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/DeductionSortSetFunction.vue'),
            },
            {
              path: "PaySetFunction",
              name: "PaySetFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/PaySetFunction.vue'),
            },
            {
              path: "SelfSupportPayFunction",
              name: "SelfSupportPayFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/SelfSupportPayFunction.vue'),
            },
            {
              path: "MemberGlobalSetFunction",
              name: "MemberGlobalSetFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/MemberGlobalSetFunction.vue'),
            },
            {
              path: "QRCodeSetFunction",
              name: "QRCodeSetFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/QRCodeSetFunction.vue'),
            },
            {
              path: "CloudHornFunction",
              name: "CloudHornFunction",
              component: () => import('@/components/Equipment/CloudHornFunction.vue'),
            },
            {
              path: "TicketEquipmentFunction",
              name: "TicketEquipmentFunction",
              component: () => import('@/components/Equipment/TicketEquipmentFunction.vue'),
            },
            {
              path: "DeviceAuthorizationFunction",
              name: "DeviceAuthorizationFunction",
              component: () => import('@/components/Equipment/DeviceAuthorizationFunction.vue'),
            },
            {
              path: "RemoteDeviceFunction",
              name: "RemoteDeviceFunction",
              component: () => import('@/components/Equipment/RemoteDeviceFunction.vue'),
            },
            {
              path: "OnLineMenberSetFunction",
              name: "OnLineMenberSetFunction",
              //component: () => import('@/components/BaseSetting/BaseSetting.vue'),
              component: () => import('@/components/BaseSetting/AllSet/OnLineMenberSetFunction.vue'),
            },
            {
              path: "EquipmentSetFunction",
              name: "EquipmentSetFunction",
              component: () => import('@/components/Equipment/EquipmentSetFunction.vue'),
            },
            {
              path: "SceneIntroductionFunction",
              name: "SceneIntroductionFunction",
              component: () => import('@/components/BaseSetting/AllSet/SceneIntroductionFunction.vue'),
            },
            {
              path: "QRToolsFunction",
              name: "QRToolsFunction",
              component: () => import('@/components/BaseSetting/AllSet/QRToolsFunction.vue'),
            },
            {
              path: "MessageSetFunction",
              name: "MessageSetFunction",
              component: () => import('@/components/BaseSetting/Message/MessageSetFunction.vue'),
            },
            {
              path: "WXRemindFunction",
              name: "WXRemindFunction",
              component: () => import('@/components/BaseSetting/Message/WXRemindFunction.vue'),
            },
            {
              path: "MemberNoticeSetFunction",
              name: "MemberNoticeSetFunction",
              component: () => import('@/components/BaseSetting/Message/MemberNoticeSetFunction.vue'),
            },
            {
              path: "ReadInstructionsSetFunction",
              name: "ReadInstructionsSetFunction",
              component: () => import('@/components/BaseSetting/Message/ReadInstructionsSetFunction.vue'),
            },

          ]
        },
        {
          path: 'SystemSetting',
          name: 'SystemSetting',
          component: () => import('@/components/SystemSetting/SystemSetting.vue'),


        },
        // {
        //   path: 'Equipment',
        //   name: 'Equipment',
        //   component: () => import('@/components/Equipment/Equipment.vue'),
        //   children: [{
        //     path: "EquipmentSetFunction",
        //     name: "EquipmentSetFunction",
        //     component: () => import('@/components/Equipment/EquipmentSetFunction.vue'),
        //   }, ]
        // },
        {
          path: 'Member',
          name: 'Member',
          component: () => import('@/components/Member/Member.vue'),
          children: [{
              path: "DeleteMemberFunction",
              name: "DeleteMemberFunction",
              component: () => import('@/components/Member/DeleteMemberFunction.vue'),
            },
            {
              path: "MemberLevelSet",
              name: "MemberLevelSet",
              component: () => import('@/components/Member/MemberLevelSet.vue'),
            },
            {
              path: "MemberTimeRecordFunction",
              name: "MemberTimeRecordFunction",
              component: () => import('@/components/Member/MemberTimeRecordFunction.vue'),
            },
            {
              path: "MemberSet",
              name: "MemberSet",
              component: () => import('@/components/Member/MemberSet.vue'),
            },
            {
              path: "MembersDepositRecordFunction",
              name: "MembersDepositRecordFunction",
              component: () => import('@/components/Member/MembersDepositRecordFunction.vue'),
            },
            {
              path: "MemberNewsChangeRecordFunction",
              name: "MemberNewsChangeRecordFunction",
              component: () => import('@/components/Member/MemberNewsChangeRecordFunction.vue'),
            },
            {
              path: "MemberCardRefundRecordFunction",
              name: "MemberCardRefundRecordFunction",
              component: () => import('@/components/Member/MemberCardRefundRecordFunction.vue'),
            },
            {
              path: "MemberLineUpRecordFunction",
              name: "MemberLineUpRecordFunction",
              component: () => import('@/components/Member/MemberLineUpRecordFunction.vue'),
            },
            {
              path: "MembersLevelChangeRecordFunction",
              name: "MembersLevelChangeRecordFunction",
              component: () => import('@/components/Member/MembersLevelChangeRecordFunction.vue'),
            },
            {
              path: "MemberRenewRecordFunction",
              name: "MemberRenewRecordFunction",
              component: () => import('@/components/Member/MemberRenewRecordFunction.vue'),
            },
            {
              path: "MemberStorageChangeRecordFunction",
              name: "MemberStorageChangeRecordFunction",
              component: () => import('@/components/Member/MemberStorageChangeRecordFunction.vue'),
            },
            {
              path: "MemberStorageTransferRecordFunction",
              name: "MemberStorageTransferRecordFunction",
              component: () => import('@/components/Member/MemberStorageTransferRecordFunction.vue'),
            },
            {
              path: "MemberReplaceRecordFunction",
              name: "MemberReplaceRecordFunction",
              component: () => import('@/components/Member/MemberReplaceRecordFunction.vue'),
            },
            {
              path: "ImportMemberFunction",
              name: "ImportMemberFunction",
              component: () => import('@/components/Member/ImportMemberFunction.vue'),
            },
            {
              path: "MemberPassTicketStorage",
              name: "MemberPassTicketStorage",
              component: () => import('@/components/Member/MemberPassTicketStorageFunction.vue'),
            },
            {
              path: "MemberCouponStoage",
              name: "MemberCouponStoage",
              component: () => import('@/components/Member/MemberCouponStoageFunction.vue'),
            },
            {
              path: "MemberAchievementRecordFunction",
              name: "MemberAchievementRecordFunction",
              component: () => import('@/components/Member/MemberAchievementRecordFunction.vue'),
            },
            {
              path: "MemberTurnLogFunction",
              name: "MemberTurnLogFunction",
              component: () => import('@/components/Member/MemberTurnLogFunction.vue'),
            },
            {
              path: "MemberCardBaoSetFunction",
              name: "MemberCardBaoSetFunction",
              component: () => import('@/components/Member/MemberCardBaoSetFunction.vue'),
            },
            {
              path: "MemberGetCardBaoRecordFunction",
              name: "MemberGetCardBaoRecordFunction",
              component: () => import('@/components/Member/MemberGetCardBaoRecordFunction.vue'),
            },
            {
              path: "FormDataFunction",
              name: "FormDataFunction",
              component: () => import('@/components/Member/FormDataFunction.vue'),
            },
            {
              path: "MembersPayItemRecordFunction",
              name: "MembersPayItemRecordFunction",
              component: () => import('@/components/Member/MembersPayItemRecordFunction.vue'),
            },
            {
              path: "MembersPayItemRecord_History1Function",
              name: "MembersPayItemRecord_History1Function",
              component: () => import('@/components/Member/MembersPayItemRecord_History1Function.vue'),
            },

            {
              path: "MembersSaleItemRecordFunction",
              name: "MembersSaleItemRecordFunction",
              component: () => import('@/components/Member/MembersSaleItemRecordFunction.vue'),
            },
            {
              path: "MembersSaleItemRecord_History1Function",
              name: "MembersSaleItemRecord_History1Function",
              component: () => import('@/components/Member/MembersSaleItemRecord_History1Function.vue'),
            },


          ]
        },

        {
          path: 'Sale',
          name: 'Sale',
          component: () => import('@/components/Sale/Sale.vue'),
          children: [{
              path: "CommodityTypeSet",
              name: "CommodityTypeSet",
              component: () => import('@/components/Sale/Commodity/CommodityTypeSet.vue')
            },
            {
              path: "CommoditySet",
              name: "CommoditySet",
              component: () => import('@/components/Sale/Commodity/CommoditySet.vue')
            },
            {
              path: "ItemSet",
              name: "ItemSet",
              component: () => import('@/components/Sale/Item/ItemSet.vue')
            },

            {
              path: "ItemTrainLogData",
              name: "ItemTrainLogData",
              component: () => import('@/components/Sale/Item/ItemTrainLogData.vue')
            },
            {
              path: "SchedulingFunction",
              name: "SchedulingFunction",
              component: () => import('@/components/Store/SchedulingFunction.vue')
            },
            {
              path: "PassTicketSet",
              name: "PassTicketSet",
              component: () => import('@/components/Sale/Item/PassTicketSet.vue')
            },
            {
              path: "MealSet",
              name: "MealSet",
              component: () => import('@/components/Sale/Meal/MealSet.vue')
            },
            {
              path: "MealType",
              name: "MealType",
              component: () => import('@/components/Sale/Meal/MealType.vue')
            },
            {
              path: "ConversionSet",
              name: "ConversionSet",
              component: () => import('@/components/Sale/ConversionSet/ConversionSet.vue')
            },
            {
              path: "SaleRecords",
              name: "SaleRecords",
              component: () => import('@/components/Sale/Records/SaleRecords.vue')
            },
            {
              path: "SaleRecord_History1Function",
              name: "SaleRecord_History1Function",
              component: () => import('@/components/Sale/HistoryRecord/SaleRecord_History1Function.vue')
            },

 {
              path: "MealSaleRecord_History1Function",
              name: "MealSaleRecord_History1Function",
              component: () => import('@/components/Sale/HistoryRecord/MealSaleRecord_History1Function.vue')
            },
            {
              path: "CommoditySaleRecords",
              name: "CommoditySaleRecords",
              component: () => import('@/components/Sale/Records/CommoditySaleRecords.vue')
            },
            {
              path: "ItemSaleRecord_History1Function",
              name: "ItemSaleRecord_History1Function",
              component: () => import('@/components/Sale/HistoryRecord/ItemSaleRecord_History1Function.vue')
            },
            {
              path: "GoodsSaleRecords_History1Function",
              name: "GoodsSaleRecords_History1Function",
              component: () => import('@/components/Sale/HistoryRecord/GoodsSaleRecords_History1Function.vue')
            },
            {
              path: "SaleRefundRecord_History1Function",
              name: "SaleRefundRecord_History1Function",
              component: () => import('@/components/Sale/HistoryRecord/SaleRefundRecord_History1Function.vue')
            },


            {
              path: "MembersSaleRecord",
              name: "MembersSaleRecord",
              component: () => import('@/components/Sale/Records/MembersSaleRecord.vue')
            },
            {
              path: "MealSaleRecord",
              name: "MealSaleRecord",
              component: () => import('@/components/Sale/Records/MealSaleRecord.vue')
            },
            {
              path: "SaleRefundRecordFunction",
              name: "SaleRefundRecordFunction",
              component: () => import('@/components/Sale/Records/SaleRefundRecordFunction.vue')
            },
            {
              path: "ItemSaleRecordFunction",
              name: "ItemSaleRecordFunction",
              component: () => import('@/components/Sale/Records/ItemSaleRecordFunction.vue')
            },
            {
              path: "CouponSetFunction",
              name: "CouponSetFunction",
              component: () => import('@/components/Coupon/CouponSetFunction.vue')
            },
            {
              path: "CouponCodeFunction",
              name: "CouponCodeFunction",
              component: () => import('@/components/Coupon/CouponCodeFunction.vue')
            }, {
              path: "ItemSaleTrainRecordFunction",
              name: "ItemSaleTrainRecordFunction",
              component: () => import('@/components/Sale/Records/ItemSaleTrainRecordFunction.vue')
            },
            {
              path: "ItemCouponSetFunction",
              name: "ItemCouponSetFunction",
              component: () => import('@/components/Coupon/ItemCouponSetFunction.vue')
            },
            {
              path: "TrainQueryFunction",
              name: "TrainQueryFunction",
              component: () => import('@/components/Train/TrainQueryFunction.vue')
            },
            {
              path: "RevenueQueryFunction",
              name: "RevenueQueryFunction",
              component: () => import('@/components/Train/RevenueQueryFunction.vue')
            },
            {
              path: "SitDownRecordsFunction",
              name: "SitDownRecordsFunction",
              component: () => import('@/components/Train/SitDownRecordsFunction.vue')
            },
            {
              path: "SeatChartSetFunction",
              name: "SeatChartSetFunction",
              component: () => import('@/components/Train/SeatChartSetFunction.vue')
            },
            {
              path: "MotorwaySetFunction",
              name: "MotorwaySetFunction",
              component: () => import('@/components/Train/MotorwaySetFunction.vue')
            },
            {
              path: "RecommenderSaleRecordFunction",
              name: "RecommenderSaleRecordFunction",
              component: () => import('@/components/Sale/Records/RecommenderSaleRecordFunction.vue')
            },
          ]
        },
        {
          path: 'Store',
          name: 'Store',
          component: () => import('@/components/Store/Store.vue'),
          children: [{
              path: "AccountLevelSet",
              name: "AccountLevelSet",
              component: () => import('@/components/SystemSetting/Accounts/AccountLevelSet.vue')
            },
            {
              path: "SchedulingFunction",
              name: "SchedulingFunction",
              component: () => import('@/components/Store/SchedulingFunction.vue')
            },
            {
              path: "PermissionSet",
              name: "PermissionSet",
              component: () => import('@/components/SystemSetting/Permission/PermissionSet.vue')
            },
            {
              path: "AccountSet",
              name: "AccountSet",
              component: () => import('@/components/SystemSetting/Accounts/AccountSet.vue')
            },
            {
              path: "WorkbenchSet",
              name: "WorkbenchSet",
              component: () => import('@/components/Workbench/WorkbenchSet.vue')
            },
            {
              path: "ActionRecordFunction",
              name: "ActionRecordFunction",
              component: () => import('@/components/Workbench/ActionRecordFunction.vue')
            },
            {
              path: "ChainStoreGroupFunction",
              name: "ChainStoreGroupFunction",
              component: () => import('@/components/ChainStore/ChainStoreGroupFunction.vue')
            },
            {
              path: "RecommenderFunction",
              name: "RecommenderFunction",
              component: () => import('@/components/Store/RecommenderFunction.vue')
            },
            {
              path: "ActivityCenterSetFunction",
              name: "ActivityCenterSetFunction",
              component: () => import('@/components/ActivityCenter/ActivityCenterSetFunction.vue')
            },
            {
              path: "ActivityCenterGetRecordFunction",
              name: "ActivityCenterGetRecordFunction",
              component: () => import('@/components/ActivityCenter/ActivityCenterGetRecordFunction.vue')
            },
            {
              path: "StickyNoteSetFunction",
              name: "StickyNoteSetFunction",
              component: () => import('@/components/ActivityCenter/StickyNoteSetFunction.vue')
            },
            {
              path: "AppointmentSetFunction",
              name: "AppointmentSetFunction",
              component: () => import('@/components/Store/AppointmentSetFunction.vue')
            },
            {
              path: "AppointmentRecordFunction",
              name: "AppointmentRecordFunction",
              component: () => import('@/components/Store/AppointmentRecordFunction.vue')
            }

          ]
        },
        // {
        //   path: 'Coupon',
        //   name: 'Coupon',
        //   component: () => import('@/components/Coupon/Coupon.vue'),
        //   children: [{
        //       path: "CouponSetFunction",
        //       name: "CouponSetFunction",
        //       component: () => import('@/components/Coupon/CouponSetFunction.vue')
        //     },
        //     {
        //       path: "CouponCodeFunction",
        //       name: "CouponCodeFunction",
        //       component: () => import('@/components/Coupon/CouponCodeFunction.vue')
        //     },
        //   ]
        // },
        {
          path: 'Warehouse',
          name: 'Warehouse',
          component: () => import('@/components/Warehouse/Warehouse.vue'),
        },
        {
          path: 'AccountModuleGroup',
          name: 'AccountModuleGroup',
          component: () => import('@/components/Admin/AccountModuleGroup.vue'),
          children: [{
              path: 'AccountSetFunction',
              name: 'AccountSetFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/AccountSetFunction.vue'),
            },
            {
              path: 'StoreSetFunction',
              name: 'StoreSetFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/StoreSetFunction.vue'),
            },
            {
              path: 'EquipmentTokenFunction',
              name: 'EquipmentTokenFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/EquipmentTokenFunction.vue'),
            },
            {
              path: 'AdminPaySetFunction',
              name: 'AdminPaySetFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/AdminPaySetFunction.vue'),
            },
            {
              path: 'StoreFunctionSetFunction',
              name: 'StoreFunctionSetFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/StoreFunctionSetFunction.vue'),
            }, ,
            {
              path: 'SQBPayBTCReturnRecordsFunction',
              name: 'SQBPayBTCReturnRecordsFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/SQBPayBTCReturnRecordsFunction.vue'),
            },
            {
              path: 'SQBPayCTBPostRecordsFunction',
              name: 'SQBPayCTBPostRecordsFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/SQBPayCTBPostRecordsFunction.vue'),
            },
            {
              path: 'SQBPayBTCPostRecordsFunction',
              name: 'SQBPayBTCPostRecordsFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/SQBPayBTCPostRecordsFunction.vue'),
            },
            {
              path: 'SQBPayCancelPostRecordsFunction',
              name: 'SQBPayCancelPostRecordsFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/SQBPayCancelPostRecordsFunction.vue'),
            },
            {
              path: 'SQBPayCancelReturnRecordsFunction',
              name: 'SQBPayCancelReturnRecordsFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/SQBPayCancelReturnRecordsFunction.vue'),
            },
            {
              path: 'SQBWapPayRecordsFunction',
              name: 'SQBWapPayRecordsFunction',
              component: () => import('@/components/Admin/AccountModuleGroup/SQBWapPayRecordsFunction.vue'),
            },
            {
              path: 'LeShuaPayReturnDataFunction',
              name: 'LeShuaPayReturnDataFunction',
              component: () => import(
                '@/components/Admin/AccountModuleGroup/LeShuaPayReturnDataFunction.vue'),
            },
            {
              path: 'ExternalApplicationAuthorizationFunction',
              name: 'ExternalApplicationAuthorizationFunction',
              component: () => import(
                '@/components/Admin/ExternalApplication/ExternalApplicationAuthorizationFunction.vue'),
            },

          ]
        },
        {
          path: 'BackstageToolsModuleGroup',
          name: 'BackstageToolsModuleGroup',
          component: () => import('@/components/Admin/BackstageToolsModuleGroup.vue'),
          children: [{
              path: 'StatisticsToolFunction',
              name: 'StatisticsToolFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/StatisticsToolFunction.vue'),
            },
            {
              path: 'ReturnMoneyToolFunction',
              name: 'ReturnMoneyToolFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/ReturnMoneyToolFunction.vue'),
            },
            {
              path: 'LeShuaReturnToolsFunction',
              name: 'LeShuaReturnToolsFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/LeShuaReturnToolsFunction.vue'),
            },
            {
              path: 'StoreLogToolFunction',
              name: 'StoreLogToolFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/StoreLogToolFunction.vue'),
            },
            {
              path: 'LogFunction',
              name: 'LogFunction',
              component: () => import('@/log/LogFunction.vue'),
            },
            {
              path: 'TokenAuthorizationFunction',
              name: 'TokenAuthorizationFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/TokenAuthorizationFunction.vue'),
            },
            {
              path: 'GoodsSaleDataFunction',
              name: 'GoodsSaleDataFunction',
              component: () => import(
                '@/components/Admin/BackstageToolsModuleGroup/GoodsSaleDataFunction.vue'),
            },

            {
              path: 'InitSystemFunction',
              name: 'InitSystemFunction',
              component: () => import('@/components/Admin/BackstageToolsModuleGroup/InitSystemFunction.vue'),
            },
            {
              path: 'SQLToolsFunction',
              name: 'SQLToolsFunction',
              component: () => import('@/components/Admin/BackstageToolsModuleGroup/SQLToolsFunction.vue'),
            },
            {
              path: 'HistoryAnalyticsDayFunction',
              name: 'HistoryAnalyticsDayFunction',
              component: () => import(
                '@/components/Admin/HistoryAnalyticsTools/HistoryAnalyticsDayFunction.vue'),
            },
            {
              path: 'HistoryAnalyticsMonthsFunction',
              name: 'HistoryAnalyticsMonthsFunction',
              component: () => import(
                '@/components/Admin/HistoryAnalyticsTools/HistoryAnalyticsMonthsFunction.vue'),
            },
            {
              path: 'HistoryAnalyticsYearFunction',
              name: 'HistoryAnalyticsYearFunction',
              component: () => import(
                '@/components/Admin/HistoryAnalyticsTools/HistoryAnalyticsYearFunction.vue'),
            },
            {
              path: 'AnalyticsGraphicsModuleDataFunction',
              name: 'AnalyticsGraphicsModuleDataFunction',
              component: () => import(
                '@/components/Admin/HistoryAnalyticsTools/AnalyticsGraphicsModuleDataFunction.vue'),
            },

          ]
        },
        {
          path: 'Storehouse',
          name: 'Storehouse',
          component: () => import('@/components/Storehouse/CreateawarehouseGroup.vue'),
          children: [{
              path: 'StorehouseFunction',
              name: 'StorehouseFunction',
              component: () => import(
                '@/components/Storehouse/Managementsettings/StorehouseFunction.vue'),
            }, {
              path: 'CreationofsuppliersFunction',
              name: 'CreationofsuppliersFunction',
              component: () => import(
                '@/components/Storehouse/Supplier/CreationofsuppliersFunction.vue'),
            }, {
              path: 'OutofstockSummaryFunction',
              name: 'OutofstockSummaryFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/OutofstockSummaryFunction.vue'),
            },
            {
              path: 'InventorySummaryFunction',
              name: 'InventorySummaryFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/InventorySummaryFunction.vue'),
            },
            {
              path: 'CommoditybrandFunction',
              name: 'CommoditybrandFunction',
              component: () => import(
                '@/components/Storehouse/Supplier/CommoditybrandFunction.vue'),
            }, {
              path: 'InventoryDetailsFunction',
              name: 'InventoryDetailsFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/InventoryDetailsFunction.vue'),
            }, {
              path: 'InventoryRecordsFunction',
              name: 'InventoryRecordsFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/InventoryRecordsFunction.vue'),
            }, {
              path: 'OutgoingDetailsFunction',
              name: 'OutgoingDetailsFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/OutgoingDetailsFunction.vue'),
            }, {
              path: 'StorageDetailsFunction',
              name: 'StorageDetailsFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/StorageDetailsFunction.vue'),
            }, {
              path: 'TransferDetailsFunction',
              name: 'TransferDetailsFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/TransferDetailsFunction.vue'),
            }, {
              path: 'WarehouseinventoryFunction',
              name: 'WarehouseinventoryFunction',
              component: () => import(
                '@/components/Storehouse/Recordquery/WarehouseinventoryFunction.vue'),
            }, {
              path: 'GodownEntryFunction',
              name: 'GodownEntryFunction',
              component: () => import(
                '@/components/Storehouse/Warehouseoperations/GodownEntryFunction.vue'),
            }, {
              path: 'GoodsoutofstockFunction',
              name: 'GoodsoutofstockFunction',
              component: () => import(
                '@/components/Storehouse/Warehouseoperations/GoodsoutofstockFunction.vue'),
            }, {
              path: 'WarehouseCheckInventoryFunction',
              name: 'WarehouseCheckInventoryFunction',
              component: () => import(
                '@/components/Storehouse/Warehouseoperations/WarehouseCheckInventoryFunction.vue'),
            }, {
              path: 'WarehouseRedeploymentFunction',
              name: 'WarehouseRedeploymentFunction',
              component: () => import(
                '@/components/Storehouse/Warehouseoperations/WarehouseRedeploymentFunction.vue'),
            },
          ]
        }
      ],
    },
    {
      path: '/SwitchStore',
      name: 'SwitchStore',
      component: () => import('@/components/Store')
    },

    {
      path: '/ApplyStore',
      name: 'ApplyStore',
      component: () => import('@/components/Store/ApplyStore.vue')
    },
    {
      path: '/Cashier',
      name: 'Cashier',
      component: () => import('@/components/Cashier'),
      children: [{
          path: 'CashierDeductionModule',
          name: 'CashierDeductionModule',
          // component: () => import('@/components/Cashier/CashierDeductionModule.vue'),
          component: () => import('@/components/content/controls/UIModules/CashierUIModule.vue'),
          children: [{
            path: 'CashierItemPayFunction',
            name: 'CashierItemPayFunction',
            component: () => import(
              '@/components/Cashier/CashierDeductionModule/CashierItemPayFunction.vue'),
          }, ]
        },
        {
          path: 'CashieCommodityModule',
          name: 'CashieCommodityModule',
          // component: () => import('@/components/Cashier/CashieCommodityModule.vue'),
          component: () => import('@/components/content/controls/UIModules/CashierUIModule.vue'),
          children: [{
              path: 'CashierCommoditySaleFunction',
              name: 'CashierCommoditySaleFunction',
              component: () => import(
                '@/components/Cashier/CashieCommodityModule/CashierCommoditySaleFunction.vue'),
            },
            {
              path: 'CashierMealRechargeFunction',
              name: 'CashierMealRechargeFunction',
              component: () => import(
                '@/components/Cashier/CashieCommodityModule/CashierMealRechargeFunction.vue'),
            },
            {
              path: 'CashierRechargeFunction',
              name: 'CashierRechargeFunction',
              component: () => import(
                '@/components/Cashier/CashieCommodityModule/CashierRechargeFunction.vue'),
            },
            {
              path: 'CashierRegisterMemberFunction',
              name: 'CashierRegisterMemberFunction',
              component: () => import(
                '@/components/Cashier/CashieCommodityModule/CashierRegisterMemberFunction.vue'),
            }
          ]
        },

        {
          path: 'CashierToolsModule',
          name: 'CashierToolsModule',
          // component: () => import('@/components/Cashier/CashierToolsModule.vue'),
          component: () => import('@/components/content/controls/UIModules/CashierHeader.vue'),
          children: [{
              path: 'PrintToolsFunction',
              name: 'PrintToolsFunction',
              component: () => import(
                '@/components/Cashier/CashierToolsModule/PrintToolsFunction.vue'),
            },
            {
              path: 'InitCardFunction',
              name: 'InitCardFunction',
              component: () => import(
                '@/components/Cashier/CashierToolsModule/InitCardFunction.vue'),
            },
            {
              path: 'AppointmentRecordToolsFunction',
              name: 'AppointmentRecordToolsFunction',
              component: () => import(
                '@/components/Cashier/CashierToolsModule/AppointmentRecordToolsFunction.vue'),
            },
            {
              path: 'MemberAchievementToolsFunction',
              name: 'MemberAchievementToolsFunction',
              component: () => import(
                '@/components/Cashier/CashierToolsModule/MemberAchievementToolsFunction.vue'),
            },

          ],
        },

        {
          path: 'CashierMemberModule',
          name: 'CashierMemberModule',
          // component: () => import('@/components/Cashier/CashierMemberModule.vue'),
          component: () => import('@/components/content/controls/UIModules/CashierHeader.vue'),
          children: [{
              path: 'CashierMemberNewsFunction',
              name: 'CashierMemberNewsFunction',
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberNewsFunction.vue'),
            },
            {
              path: 'CashierMemberAllRecordsFunction',
              name: 'CashierMemberAllRecordsFunction',
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberAllRecordsFunction.vue'),
            },
            {
              path: 'CashierMemberReplaceFunction',
              name: 'CashierMemberReplaceFunction',
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberReplaceFunction.vue'),
            },
            {
              path: "CashierMemberReturnSaleFunction",
              name: "CashierMemberReturnSaleFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberReturnSaleFunction.vue'),
            },
            {
              path: "CashierMemberCancellationFunction",
              name: "CashierMemberCancellationFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberCancellationFunction.vue'),
            },
            {
              path: "CashierMemberLevelChangeFunction",
              name: "CashierMemberLevelChangeFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberLevelChangeFunction.vue'),
            },
            {
              path: "CashierMemberRenewFunction",
              name: "CashierMemberRenewFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberRenewFunction.vue'),
            },
            {
              path: "CashierMemberStorageChangeFunction",
              name: "CashierMemberStorageChangeFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberStorageChangeFunction.vue'),
            },
            {
              path: "CashierMemberStorageTransferFunction",
              name: "CashierMemberStorageTransferFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberStorageTransferFunction.vue'),
            },
            {
              path: "CashierMemberSQBPayQuerysFunction",
              name: "CashierMemberSQBPayQuerysFunction",
              component: () => import(
                '@/components/Cashier/CashierMemberModule/CashierMemberSQBPayQuerysFunction.vue'),
            },




          ]
        },
        {
          path: 'CashieVerificationModule',
          name: 'CashieVerificationModule',
          component: () => import('@/components/content/controls/UIModules/CashierUIModule.vue'),
          children: [

          ]
        }

      ]
    },

    {
      path: '/CompanyUI',
      name: 'CompanyUI',
      component: () => import('@/CompanyUI/CompanyAccountLogin.vue')
    },

    {
      path: '*',
      // component: Login
      component: () => import('@/components/Login')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js